// Copyright (C) 2023 TANNER AG

import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { useFeaturedNavQuery, useQuickAccessLinksQuery } from "../../../graphql";
import HomeCardItem from "./HomeCardItem";
import Spinner from "../../../components/Spinner";
import QuickAccessDialog from "../../../components/quickaccess/QuickAccessDialog";
import useLocale from "../../../hooks/uselocale";
import useTranslation from "../../../hooks/usetranslation";
import { runtimeConfig } from "../../../lib/utils";

const HomeCards: React.FC = () => {
    const { t } = useTranslation();
    const { locale: storeLocale } = useLocale();
    const [quickAccessOpen, setQuickAccessOpen] = React.useState(false);

    let locale = storeLocale;

    if (storeLocale === "de") {
        locale = "de_DE";
    }

    const [{ data, fetching }] = useFeaturedNavQuery({ variables: { locale } });
    const [{ data: quickAccessData, fetching: quickAccessFetching, error: quickAccessError }] = useQuickAccessLinksQuery({
        variables: { locale: storeLocale }
    });

    const navItems = data?.featuredNav ?? [];
    const quickAccessLinks = quickAccessData?.quickAccessLinks ?? [];
    const showQuickAccess = quickAccessFetching || quickAccessLinks.length > 0;

    return (
        <>
            <Typography variant="h4" color="black" textTransform="uppercase">
                {t("featured")}
            </Typography>
            {fetching ? (
                <Spinner />
            ) : (
                <Grid container spacing={3} paddingTop={3}>
                    {showQuickAccess && (
                        <Grid key="quick-access" item xs={12} md={6}>
                            <HomeCardItem
                                title={t("quick_access_title")}
                                url="/quick-access"
                                staticSrc={`${runtimeConfig.basePath}/Schnellzugriff_Teaser_MyBus.png`}
                                onClick={() => setQuickAccessOpen(true)}
                            />
                        </Grid>
                    )}
                    {navItems.map((navItem, index) => (
                        <Grid key={navItem.id} item xs={12} md={6}>
                            <HomeCardItem
                                title={navItem.title}
                                url={navItem.url}
                                src={navItem.image}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}
            <QuickAccessDialog
                open={quickAccessOpen}
                onClose={() => setQuickAccessOpen(false)}
                links={quickAccessLinks}
                fetching={quickAccessFetching}
                error={Boolean(quickAccessError)}
            />
        </>
    );
};

export default HomeCards;
